import React, { useMemo, useState } from "react";
import { Button } from "reactstrap";
import { useChangeOrderCustomer, useCheckRole } from "hooks";
import CoordinateCollectorOrder from "./OrderDetailFunction/CoordinateCollectorOrder";
import ChangeStatus from "./OrderDetailFunction/ChangeStatus";
import ViewParentOrder from "./OrderDetailFunction/ViewParentOrder";
import WarningNote from "pages/Orders/OrderDetail/OrderDetailPage/WarningNote";
import CancelOrder from "./OrderDetailFunction/CancelOrder";
import { STATUS } from "constants/order";
import ChangeCustomerForm from "pages/Orders/OrderDetail/ChangeCustomerForm/ChangeCustomerForm";

const Toolbar = ({ orderDetail, refetchDetail }) => {
  const { isLogAdmin, isHubAdmin } = useCheckRole();
  const [isOpenChangeStatusModal, setIsOpenChangeStatusModal] = useState(false);
  const [isOpenCoordinateModal, setIsOpenCoordinateModal] = useState(false);
  const [isOpenChangeCustomerModal, setIsOpenChangeCustomerModal] =
    useState(false);

  const isAcceptCoordinate = useMemo(() => {
    if (orderDetail && isLogAdmin) {
      return (
        orderDetail.status === STATUS.NEW ||
        orderDetail.status === STATUS.PENDING
      );
    }

    return false;
  }, [orderDetail, isLogAdmin]);

  const isAcceptViewParentOrder = useMemo(() => {
    if (orderDetail && (isLogAdmin || isHubAdmin)) {
      return Boolean(orderDetail?.parent_id);
    }

    return false;
  }, [orderDetail, isLogAdmin, isHubAdmin]);

  const isAcceptChangeStatus = useMemo(() => {
    if (orderDetail && isLogAdmin) {
      return (
        orderDetail.status === STATUS.COORDINATED ||
        orderDetail.status === STATUS.RECEIVED
      );
    }

    return false;
  }, [orderDetail, isLogAdmin]);

  const isAcceptCancelOrder = useMemo(() => {
    if (orderDetail) {
      return (
        isLogAdmin ||
        orderDetail.status === STATUS.NEW ||
        orderDetail.status === STATUS.PENDING
      );
    }

    return false;
  }, [orderDetail, isLogAdmin]);

  const isAcceptChangeCustomer = useMemo(() => {
    if (orderDetail) {
      return isLogAdmin;
    }

    return false;
  }, [orderDetail, isLogAdmin]);

  // Change Order Customer
  const onSuccessChangeOrderCustomer = () => {
    refetchDetail();
    setIsOpenChangeCustomerModal(false);
  };
  const {
    mutate: changeOrderCustomer,
    isLoading: isLoadingChangeOrderCustomer,
  } = useChangeOrderCustomer(onSuccessChangeOrderCustomer);

  const handleChangeOrderCustomer = data => {
    changeOrderCustomer({ orderId: orderDetail?.id, data });
  };

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
      <div className="d-flex flex-wrap align-items-center gap-2">
        <Button
          color="primary"
          onClick={e =>
            orderDetail?.order_code &&
            navigator.clipboard.writeText(orderDetail?.order_code)
          }
        >
          Mã đơn: {orderDetail?.order_code}
        </Button>
        <Button
          color="success"
          // className="btn-info"
          onClick={e =>
            orderDetail?.ref_code &&
            navigator.clipboard.writeText(orderDetail?.ref_code)
          }
        >
          Mã tham chiếu: {orderDetail?.ref_code || "Chưa có"}
        </Button>
      </div>
      <div className="d-flex flex-wrap align-items-center gap-2">
        {isAcceptViewParentOrder && <ViewParentOrder />}
        {isAcceptCoordinate && (
          <>
            <Button
              color="info"
              outline
              onClick={() => setIsOpenCoordinateModal(true)}
            >
              Điều phối
            </Button>
            <CoordinateCollectorOrder
              orderIds={[orderDetail?.id]}
              isOpenCoordinateModal={isOpenCoordinateModal}
              setIsOpenCoordinateModal={setIsOpenCoordinateModal}
              hubId={orderDetail?.from_hub}
              orderDetail={orderDetail}
              refetchSuccess={refetchDetail}
            />
          </>
        )}
        {isAcceptChangeStatus && (
          <>
            <Button
              color="success"
              outline
              onClick={() => setIsOpenChangeStatusModal(true)}
            >
              Đổi trạng thái
            </Button>
            <ChangeStatus
              orderDetail={orderDetail}
              isOpenChangeStatusModal={isOpenChangeStatusModal}
              setIsOpenChangeStatusModal={setIsOpenChangeStatusModal}
              refetchDetail={refetchDetail}
            />
          </>
        )}
        {isAcceptChangeCustomer && (
          <>
            <Button
              color="primary"
              onClick={() => setIsOpenChangeCustomerModal(true)}
              outline
            >
              Đổi khách hàng
            </Button>
            <ChangeCustomerForm
              isOpenModal={isOpenChangeCustomerModal}
              toggleModal={() => setIsOpenChangeCustomerModal(false)}
              handleChangeOrderCustomer={handleChangeOrderCustomer}
              isLoadingChangeOrderCustomer={isLoadingChangeOrderCustomer}
            />
          </>
        )}

        <WarningNote orderData={orderDetail} />
        {isAcceptCancelOrder && (
          <CancelOrder
            orderDetail={orderDetail}
            refetchDetail={refetchDetail}
          />
        )}
      </div>
    </div>
  );
};

export default Toolbar;
